import { HoursChip, LocationChip, SalaryChip } from '@components/Chips';
import { CbShadowSubtle } from '@coolblue-development/design-tokens';
import { ChipGroup } from '@coolblue-development/freddy';
import { type ChipUSPs as ChipUSPsType, ChipUSPsVariant } from '@sharedTypes';

import { LocationSelector } from './LocationSelector';
import { RelocationChipModal } from './RelocationChipModal';

type Props = {
  chipUSPs: ChipUSPsType;
};

export const ChipUSPs = ({ chipUSPs }: Props) => {
  const LocationVariant = () => {
    switch (chipUSPs.variant) {
      case ChipUSPsVariant.LocationSpecific:
        return <LocationChip locationValue={chipUSPs.location.displayName} />;
      case ChipUSPsVariant.Group:
        return <LocationSelector locations={chipUSPs.locations} />;
    }
  };

  return (
    <ChipGroup
      size={{ sm: 'small', md: 'medium' }}
      sx={{ '> span': { boxShadow: CbShadowSubtle } }}
    >
      {chipUSPs.relocationPossible && <RelocationChipModal />}
      {LocationVariant()}
      <HoursChip min={chipUSPs.hoursRange.min} max={chipUSPs.hoursRange.max} />
      <SalaryChip salaryValue={chipUSPs.salaryValue} salaryRange={chipUSPs.salaryRange} />
    </ChipGroup>
  );
};
